import React, { useEffect, useState } from "react";
import {
  Col,
  Card,
  Table,
  Alert,
  Spinner,
  Dropdown,
  Modal,
} from "react-bootstrap";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown";
import swal from "sweetalert";
function WareHouse() {
  var history = useHistory();
  const [stores, setStores] = useState([]);
  const [spinner, setSpinner] = useState(true);
  const [catId, setCatId] = useState("");
  const [show1, setShow1] = useState(false);
  const [selectedShop, setSelectedShop] = useState([]);
  const [allShopObject, setAllShopObject] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [shop, setShop] = useState("");
  function getShops(shop) {
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/shop/get-all-shop-details`)
      .then((res) => {
        setAllShopObject(res.data.details);
        setSelectedShop(shop);
      });
  }
  function getData() {
    axios
      .get(`${Baseurl.baseurl6}/go-grocery/warehouse/get-all-warehouse`)
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setStores(res.data.details);
        }
      });
  }

  useEffect(() => {
    getData();
  }, []);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const removeFromSubStore = (selectedValues, removed) => {
    console.log("selectionsss", removed);
    if (removed && deleteStatus) {
      deleteCategoryfromSubShop(removed._id);
    }
  };
  function deleteCategoryfromSubShop(id) {
    let catFields = {
      shopId: id,
    };
    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/warehouse/remove-shop-from-warehouse/${catId}`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }
  const selection1 = (selectedValues) => {
    let name = [];
    selectedValues.map((val) => {
      name.push(val._id);
    });

    setShop(name);
  };
  function addCategoryToSubStore() {
    if (selectedShop.length !== 0) {
      shop.splice(0, selectedShop.length);
    }
    let catFields = {
      shopId: shop,
    };
    axios
      .put(
        `${Baseurl.baseurl6}/go-grocery/warehouse/add-shop-to-warehouse/${catId}`,
        catFields
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }
  return (
    <Col lg={12}>
      <Modal
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {deleteStatus ? "Remove Category" : "Add Category"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
                Category<span className="text-danger">*</span>
              </label>
            </div>
            <div className="col-sm-10">
              <Multiselect
                options={allShopObject}
                displayValue="Name"
                onRemove={removeFromSubStore}
                onSelect={selection1}
                selectedValues={selectedShop}
              />
            </div>
          </div>
        </Modal.Body>
        {!deleteStatus && (
          <Modal.Footer>
            <button
              onClick={() => {
                addCategoryToSubStore();
              }}
              className="btn btn-primary"
            >
              ADD
            </button>
          </Modal.Footer>
        )}
      </Modal>
      {spinner ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Card
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <Card.Header>
            <div></div>
            <button
              onClick={() => {
                history.push(`/WareHouse-Managment/459fhu4749fhfhf7585/Create`);
              }}
              className="btn btn-primary"
            >
              Add WareHouse
            </button>
          </Card.Header>
          <Card.Body>
            <div id="job_data" className="dataTables_wrapper ">
              <Table className="text-white">
                <thead>
                  <tr>
                    <th>
                      <strong>NAME</strong>
                    </th>
                    <th>
                      <strong>Address</strong>
                    </th>

                    <th>
                      <strong>CityName</strong>
                    </th>

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {stores &&
                    stores.map((val, key) => (
                      <tr key={val.id}>
                        <td>{val.Name}</td>
                        <td>{val.Address}</td>

                        <td>{val.CityName}</td>

                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  history.push(
                                    `/WareHouse-Managment/${val._id}/Update`,
                                    val
                                  );
                                }}
                              >
                                Update
                              </Dropdown.Item>

                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                  getShops(val.ShopId);
                                  setDeleteStatus(false);
                                }}
                              >
                                Add Shop
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setCatId(val._id);
                                  setShow1(true);
                                  getShops(val.ShopId);
                                  setDeleteStatus(true);
                                }}
                              >
                                Remove Shop
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              {stores.length === 0 && (
                <Alert
                  variant="success"
                  className="alert-dismissible fade show text-center"
                >
                  Zero stores
                </Alert>
              )}
            </div>
          </Card.Body>
        </Card>
      )}
    </Col>
  );
}

export default WareHouse;
